module.exports = __webpack_public_path__ + "img/main_community_Image.7789f2a6.jpg";